
import { Component, OnInit, EventEmitter, Output, AfterViewInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ValidatorFn, AbstractControl, AsyncValidatorFn, FormArray } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { EditEngagementMemoryServiceService } from '../../edit-engagement-memory-service/edit-engagement-memory-service.service';
import { EngagementManagementService } from '../../../../framework/services/engagement-mgmt.service';
import { max } from 'rxjs-compat/operator/max';
import { url } from 'inspector';
import { CommonService } from 'src/framework/services/common.service';
import { ɵINTERNAL_BROWSER_DYNAMIC_PLATFORM_PROVIDERS } from '@angular/platform-browser-dynamic';
import { element } from 'protractor';
//import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { SelectItem, SelectItemGroup, MessageService } from 'primeng/api';
import { DocumentManagementService } from 'src/framework/services/manage-doc.service';
import { stat } from 'fs';
import { LanguageService } from 'src/framework/services/language.service';
import { CategoryConstant } from 'src/app/shared/app-constants/category-constants';



@Component({
  selector: 'app-basic-details-edit',
  templateUrl: './basic-details-edit.component.html',
  styleUrls: ['./basic-details-edit.component.css']
})
export class BasicDetailsEditComponent implements OnInit{
  basicDetailsEdit = false;
  languageBasedRoles = [];
  jurisdictionOption = [];
  engagementDynamicDetails: DynamicDetailsModel[];
  detailsLanguageMapping = [];
  value: Date;
  maxDateValue: Date = new Date();
  engagementDetailsForms: EngagementDetailsForm;
  basicDetailsForm: FormGroup;
  urlDomain: string = "https://ey.com/ca/";
  isEnglishSelected = false;
  @Output() showNextControl = new EventEmitter<string>()
  @Output() showPreviousControl = new EventEmitter<string>();
  shortUrl: { url, isSaved }[] = new Array<{ url, isSaved }>();
  clonedShortUrls: { url, isSaved }[] = new Array<{ url, isSaved }>();
  clonedEngagementDetailsForm: EngagementDetailsForm;
  clonedFormDetails: FormGroup;
  clonedLanguageBasedDetails: DynamicDetailsModel;
  editLanguageName: string = "";
  selectedLangStatusJson: any;
  defaultEngStatusJson: any;
  selectedLangLabelJson: any;
  defaultEngLangLabelJson: any;
  showLanguageBasedDetails = false;
  clonedLanguageBasedDetailsForm: FormGroup;
  isConfidentialReadonly = true;
  yearRange: string;
  users: any[] = [];
  status: any[] = [];
  engagementStatus: string = "";
  engagementDetailsHistoryId: number = 0;
  showAddEnagementBasedDetails: boolean = false;
  addEnagementDetailsForm: FormGroup;
  addEnagementDetailsModel: DynamicDetailsModel;
  addDeltailsSelectedLanguage: any = {};
  languageDropDown: any[] = [];
  selectedLanguageId: number;
  defaultEnglishJson: any;
  selectedLangDateJson: any;
  defaultEngDateJson: any;
  localeSetting: any;
  islabelLoaded: boolean = false;
  selectedAppLanguageJson: any;
  tinyMceConfig: any;
  showEditor=false;
  rawApproverList: any[] = [];
  approver: any;
  authorizerList: SelectItemGroup[] = [
    { label: 'Owners', items: [] },
    { label: 'Reviewers', items: [] },
    { label: 'PPAP', items: [] },
    { label: 'Sr. Managers', items: [] },
    { label: 'Admin', items: [] }
  ];
  isSameApproverSelected: boolean = false;

  loggedInUserModel: any = {};
  showLog = false;
  engagementDetailsLog = [];

  constructor(private engagementMemoryService: EditEngagementMemoryServiceService,
    private engagementManagementService: EngagementManagementService,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private languageService: LanguageService,
    private commonService: CommonService, private manageDocService: DocumentManagementService,
    private messageService: MessageService) {
    this.yearRange = (new Date().getFullYear()) - 20 + ':' + (new Date().getFullYear());
    let selectedLanguages = this.engagementMemoryService.getSelectedLanguages();
    this.languageBasedRoles = this.engagementMemoryService.getLanguageBasedRoles();
    this.jurisdictionOption = this.engagementMemoryService.getJurisdictionOption();
    this.engagementDetailsForms = new EngagementDetailsForm(new Date(), false, '', false, '', '');
    this.clonedEngagementDetailsForm = new EngagementDetailsForm(new Date(), false, '', false, '', '');
    this.addEnagementDetailsModel = new DynamicDetailsModel("", "", "", "", 0, 0, false, false, 0, "", false)
    this.getApproverList(this.engagementMemoryService.getEngagementId())
    this.engagementDynamicDetails = new Array<DynamicDetailsModel>();
    let engagementLanguageDetailsForm = [];

    this.clonedLanguageBasedDetails = new DynamicDetailsModel("", "", "", "", 0, 0, false, false, 0, "", false);
    if (selectedLanguages.length > 0) {
      for (let i = 0; i < selectedLanguages.length; i++) {
        let dynamicModel = new DynamicDetailsModel("", "", selectedLanguages[i].name, '', selectedLanguages[i].languageId, 0, false, false, 1, "Draft", false);
        this.engagementDynamicDetails.push(dynamicModel);
        engagementLanguageDetailsForm.push(this.getEngagementDetailsFormGroup(this.engagementDynamicDetails[i]));
        if (selectedLanguages[i].name == "English")
          this.isEnglishSelected = true;
      }
      if (sessionStorage.getItem('engagementData')) {
        let sessionEngObj = JSON.parse(sessionStorage.getItem('engagementData'));
        if (sessionEngObj['statusId'] == 2) {
          this.isConfidentialReadonly = false;
        }
      }
    }

    this.basicDetailsForm = this.fb.group({
      initialDateControl: [this.engagementDetailsForms.IntialDate],
      isConfidentialControl: [false],
      isFormalControl: [false],
      pastDateControl: [this.engagementDetailsForms.PastDate],
      eyRole: [this.engagementDetailsForms.EYRole],
      jurisdiction: [this.engagementDetailsForms.Jurisdiction],
      engagementLanguageBasedDetails: this.fb.array(engagementLanguageDetailsForm)
    });

    this.clonedFormDetails = this.fb.group({
      clonedInitialCtrl: [this.clonedEngagementDetailsForm.IntialDate,],
      clonedPastCtrl: [this.clonedEngagementDetailsForm.PastDate],
      clonedShortUrlGroup: this.fb.array([]),
      clonedIsFormalCtrl: [this.clonedEngagementDetailsForm.IsFormal],
      clonedIsConfidentialCtrl: [this.clonedEngagementDetailsForm.IsConfidential],
      clonedEyRole: [this.clonedEngagementDetailsForm.EYRole, [this.engagementRoleValidation()]],
      clonedJurisdiction: [this.clonedEngagementDetailsForm.Jurisdiction, [this.jurisdictionValidation()]],
    });

    this.clonedLanguageBasedDetailsForm = this.fb.group({
      'clonedEngagementName': [this.clonedLanguageBasedDetails.engagementName, [Validators.required]],
      'clonedEngagementDescription': [this.clonedLanguageBasedDetails.descritpion]
    })

    this.getUnselectedLanguages();

    this.addEnagementDetailsForm = this.fb.group({
      'addLanguageCtrl': [this.addDeltailsSelectedLanguage, [this.addLanguageValidator()]],
      'addEngagementName': [this.addEnagementDetailsModel.engagementName, [Validators.required], [this.engagementNameDuplicateValidator()]],
      'addEngagementDescription': [this.addEnagementDetailsModel.descritpion]
    })

    if (sessionStorage.getItem('engagementData')) {
      let sessionEngObj = JSON.parse(sessionStorage.getItem('engagementData'));
      this.engagementStatus = sessionEngObj['statusName'];
    }

    if (localStorage.getItem("userModel")) {
      this.loggedInUserModel = JSON.parse(localStorage.getItem("userModel"));
    }
  }

  ngOnInit(): void {
    this.spinner.show();
    this.configureTinyMce();
    this.loadLanguageLabel();
    this.commonService.getStatus().subscribe((response) => {
      if (response.responseStatus == 1) {

      } else {
        if (response.data && response.data.length > 0) {
          this.status = response.data;
          this.loadEngagement();
        }
      }
    })
  }
  // ngAfterViewInit() {

  // }

    
  configureTinyMce() {
    const that = this;
    this.tinyMceConfig = {
      branding: false,
      toolbar_mode: 'sliding',
      toolbar_sticky: false,
      inline: false,
      statusbar: false,
      theme: "silver",
      resize: false,
      skin: "oxide",
      skin_url: 'assets/skins/ui/oxide',
      base_url: '/tinymce',  
      suffix: '.min',
      plugins: [
        "print preview   importcss autoresize searchreplace autolink autosave save directionality  visualblocks visualchars fullscreen image link media  template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists  wordcount   imagetools textpattern noneditable help code charmap  emoticons paste table"],
      menubar: 'edit insert view  format table tools help',
      force_br_newlines: false,
      //force_p_newlines: false,
      //forced_root_block: '',
      // content_css: [
      //   '//fonts.googleapis.com/css?family=EYFontRegular',
      // ],
      paste_as_text: true,
      paste_text_sticky: true,
      font_formats: 'EYFontRegular=EYFontRegular;',
      theme_advanced_fonts: "EYFontRegular=EYFontRegular",
      extended_valid_elements: "@[id|class|title|style|onmouseover|onclick]," +
        "a[name|href=javascript:void(0);|target|title|alt]," +
        "#div,blockquote,-ol,-ul,-li,br,img[src|height|width],-sub,-sup,-b,-i,-u," +
        "-span[data-mce-type],hr,",
      toolbar: 'bold italic backcolor | ' +
        'bullist numlist outdent indent | alignright alignjustify |' +
        '   alignleft aligncenter | removeformat |' +
        ' help '
    };
  }

  loadLanguageLabel() {
    let englishLanguageMappings, selectedLanguageMappings: any;
    let englishStatusMappings, selectedLangStatusMappings: any;
    let englishLangLabelMappings, selectedLangLabelMappings: any;
    let englishDateMappings, selectedLangDateMappings: any;

    return new Promise((resolve, reject) => {
      if (sessionStorage.getItem('selectedLanguageId')) {
        this.selectedLanguageId = 1;//JSON.parse(sessionStorage.getItem('selectedLanguageId'));
      }

      this.languageService.currentData.subscribe(data => {
        this.selectedLanguageId = data.Id
      });


      this.languageService.mySubject.subscribe((data) => {
        var languageMappings = data;
        if (languageMappings?.length > 0) {

          englishLanguageMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.EditEngagement.toLowerCase()
            && Number(item?.languageId) === 1)[0];

          englishStatusMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.Status.toLowerCase()
            && Number(item?.languageId) === 1)[0];

          englishLangLabelMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.Language.toLowerCase()
            && Number(item?.languageId) === 1)[0];

          englishDateMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.Calendar.toLowerCase()
            && Number(item?.languageId) === 1)[0];

          if (englishLanguageMappings?.isGlobal) {
            selectedLanguageMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.EditEngagement.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedLanguageId))[0];

            selectedLangStatusMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.Status.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedLanguageId))[0];

            selectedLangLabelMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.Language.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedLanguageId))[0];

            selectedLangDateMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.Calendar.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedLanguageId))[0];
          }
          else {
            if (Number(this.selectedLanguageId) === 2) {
              selectedLanguageMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.EditEngagement.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedLanguageId))[0];

              selectedLangStatusMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.Status.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedLanguageId))[0];

              selectedLangLabelMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.Language.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedLanguageId))[0];

              selectedLangDateMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.Calendar.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedLanguageId))[0];
            }
            else {
              selectedLanguageMappings = englishLanguageMappings;
              selectedLangStatusMappings = englishStatusMappings;
              selectedLangLabelMappings = englishLangLabelMappings;
              selectedLangDateMappings = englishDateMappings;

            }
          }
          this.selectedAppLanguageJson = JSON.parse(selectedLanguageMappings.languageMappingJSON);

          this.defaultEnglishJson = JSON.parse(englishLanguageMappings.languageMappingJSON);


          this.selectedLangLabelJson = JSON.parse(selectedLangLabelMappings?.languageMappingJSON ?? englishLangLabelMappings.languageMappingJSON);
          this.defaultEngLangLabelJson = JSON.parse(englishLangLabelMappings.languageMappingJSON);

          this.selectedLangStatusJson = JSON.parse(selectedLangStatusMappings?.languageMappingJSON ?? englishStatusMappings.languageMappingJSON);
          this.defaultEngStatusJson = JSON.parse(englishStatusMappings.languageMappingJSON);

          this.selectedLangDateJson = JSON.parse(selectedLangDateMappings?.languageMappingJSON ?? englishDateMappings.languageMappingJSON);
          this.defaultEngDateJson = JSON.parse(englishDateMappings.languageMappingJSON);

          this.setCalendarLocale();

          this.languageDropDown.forEach(item => {
            item.name = this.languageReplacer(item.name);
          });
          this.islabelLoaded = true;
          resolve(1);
        }
        else {

        }
      });
    })
      .catch(err => {


        console.log(err);
      });
  }

  labelReplacer(labelKey): string {
    return this.selectedAppLanguageJson[labelKey]?.trim() ? this.selectedAppLanguageJson[labelKey] ?? 'text not found' : this.defaultEnglishJson[labelKey] ?? 'text not found';
  }


  languageReplacer(labelKey): string {
    return this.selectedLangLabelJson[labelKey]?.trim() ? this.selectedLangLabelJson[labelKey] ?? 'text not found' : this.defaultEngLangLabelJson[labelKey] ?? 'text not found';
  }


  statusReplacer(labelKey): string {
    return this.selectedLangStatusJson[labelKey]?.trim() ? this.selectedLangStatusJson[labelKey] ?? 'text not found' : this.defaultEngStatusJson[labelKey] ?? 'text not found';
  }

  calendarReplacer(labelKey): string {
    return this.selectedLangDateJson[labelKey]?.trim() ? this.selectedLangDateJson[labelKey] ?? 'text not found' : this.defaultEngDateJson[labelKey] ?? 'text not found';
  }

  dayOrMonthNameShort(name, length): string {
    let shortName = '';
    if (name?.trim()?.length == 0)
      shortName = 'Text not found';
    else if (name?.trim()?.length > 0 && name?.trim()?.length < length)
      shortName = name;
    else
      shortName = name.substr(0, length);
    return shortName;
  }

  setCalendarLocale() {
    this.localeSetting = {
      firstDayOfWeek: 0,
      dayNames: [
        this.calendarReplacer("SUN"),
        this.calendarReplacer("MON"), this.calendarReplacer("TUE"), this.calendarReplacer("WED"),
        this.calendarReplacer("THU"), this.calendarReplacer("FRI"), this.calendarReplacer("SAT")
      ],
      dayNamesShort: [
        this.dayOrMonthNameShort(this.calendarReplacer("SUN"), 3),
        this.dayOrMonthNameShort(this.calendarReplacer("MON"), 3), this.dayOrMonthNameShort(this.calendarReplacer("TUE"), 3),
        this.dayOrMonthNameShort(this.calendarReplacer("WED"), 3), this.dayOrMonthNameShort(this.calendarReplacer("THU"), 3),
        this.dayOrMonthNameShort(this.calendarReplacer("FRI"), 3), this.dayOrMonthNameShort(this.calendarReplacer("SAT"), 3)
      ],
      dayNamesMin: [
        this.dayOrMonthNameShort(this.calendarReplacer("SUN"), 1),
        this.dayOrMonthNameShort(this.calendarReplacer("MON"), 1), this.dayOrMonthNameShort(this.calendarReplacer("TUE"), 1),
        this.dayOrMonthNameShort(this.calendarReplacer("WED"), 1), this.dayOrMonthNameShort(this.calendarReplacer("THU"), 1),
        this.dayOrMonthNameShort(this.calendarReplacer("FRI"), 1), this.dayOrMonthNameShort(this.calendarReplacer("SAT"), 1)
      ],
      monthNames: [
        this.calendarReplacer("JAN"), this.calendarReplacer("FEB"), this.calendarReplacer("MAR"),
        this.calendarReplacer("APR"), this.calendarReplacer("MAY"), this.calendarReplacer("JUN"),
        this.calendarReplacer("JUL"), this.calendarReplacer("AUG"), this.calendarReplacer("SEP"),
        this.calendarReplacer("OCT"), this.calendarReplacer("NOV"), this.calendarReplacer("DEC")
      ],
      monthNamesShort: [
        this.calendarReplacer("JAN"), this.calendarReplacer("FEB"), this.calendarReplacer("MAR"),
        this.calendarReplacer("APR"), this.calendarReplacer("MAY"), this.calendarReplacer("JUN"),
        this.calendarReplacer("JUL"), this.calendarReplacer("AUG"), this.calendarReplacer("SEP"),
        this.calendarReplacer("OCT"), this.calendarReplacer("NOV"), this.calendarReplacer("DEC")
      ],
      today: this.calendarReplacer('TODAY'),
      clear: this.calendarReplacer('CLEAR')
    }
  }


  loadEngagement() {
    this.spinner.show();
    this.engagementManagementService.getEngagementBasicDetails(this.engagementMemoryService.getEngagementId()).subscribe((response) => {
      if (response.responseStatus == 1) {

      } else {
        this.engagementDetailsForms.IntialDate = response.data.intialDate ? new Date(response.data.intialDate) : undefined;
        let shortUrls = response.data.shortUrl.split('^');
        for (let i = 0; i < shortUrls.length; i++) {
          this.shortUrl.push({ url: shortUrls[i].substring(18), isSaved: true })
        }
        this.engagementDetailsForms.IsConfidential = response.data.isConfidential;
        this.engagementDetailsForms.IsFormal = response.data.isFormal;
        this.engagementDetailsForms.PastDate = response.data.pastDate ? new Date(response.data.pastDate) : undefined;
        this.engagementDetailsForms.EYRole = this.languageBasedRoles.find(t => t.roleLanguageMappingId == response.data.engagementRoleLanguageMappingId);
        this.engagementDetailsForms.Jurisdiction = this.jurisdictionOption.find(t => t.jurisdictionLanguageMappingId == response.data.jurisdictionLanguageMappingId)
        if (response.data.engagementDetails && response.data.engagementDetails.length > 0) {
          response.data.engagementDetails.forEach(element => {
            let dynamicModel = this.engagementDynamicDetails.find(t => t.languageId == element.languageId)
            if (dynamicModel) {
              dynamicModel.engagementDetailsId = element.engagementDetailsId;
              dynamicModel.engagementName = element.engagementName;
              dynamicModel.descritpion = element.engagementDescription
              dynamicModel.isEditEnabled = true;
              dynamicModel.statusId = element.statusId
              dynamicModel.status = this.status.find(t => t.statusId == element.statusId)?.name;
              dynamicModel.isDraftExists = element.isStatusExist
            }
          });

        }
      }
      this.spinner.hide();
    })
  }

  getEngagementDetailsFormGroup(model: DynamicDetailsModel): FormGroup {
    return this.fb.group({
      engagementName: [model.engagementName, [Validators.required], [this.engagementNameDuplicateValidator()]],
      engagementDescription: [model.descritpion]
    });
  }

  getShortUrlFormGroup(): FormGroup {
    return this.fb.group({
    //  clonedshortURLControl: ['', [Validators.required, Validators.maxLength(25), this.validateShortURl()], [this.shortUrlDuplicateValidator()]],
      clonedshortURLControl: ['', [Validators.required, Validators.maxLength(25), this.validateShortURl()], ],
    }, { updateOn: 'blur' });
  }

  engagementRoleValidation(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (control.touched && control.value && control.value?.engagementRoleId > 0) {
        return null;
      } else if (!control.touched && control.value && control.value?.engagementRoleId > 0) {
        return null;
      }
      return { 'roleRequired': 'Language is required' };
    }
  }

  validateShortURl(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      const url = this.urlDomain.trim() + control.value;
      const URL_REGEXP = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/gm
      if (control.valid && !url.match(URL_REGEXP)) {
        return { 'invalidUrl': 'invalid url' }
      }
      return null;
    }
  }
  shortUrlDuplicateValidator(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<{ [key: string]: any | null }> => {
      if (control.dirty && control.value.length > 0) {
        return this.engagementManagementService.findShortUrl(this.urlDomain + control.value);
      }
      return of(null);
    }
  }

  addShortUrlControl() {
    this.clonedShortUrls.push({ url: '', isSaved: false });
    (<FormArray>this.clonedFormDetails.get('clonedShortUrlGroup')).push(this.getShortUrlFormGroup());
  }

  removeShortUrl(event, i) {
    let control = (<FormArray>this.clonedFormDetails.get('clonedShortUrlGroup'))
    control.removeAt(i);
    this.clonedShortUrls.splice(i, 1);
  }

  cloneEngagementDetails() {
    this.resetShortUrl();
    this.clonedEngagementDetailsForm = {
      ...this.engagementDetailsForms,
      IntialDate: this.engagementDetailsForms.IntialDate ? this.engagementDetailsForms.IntialDate : new Date()
    };
    for (let i = 0; i < this.shortUrl.length; i++) {
      if (i == 0 && this.shortUrl[i].url == '')
        break;
      let control = this.getShortUrlFormGroup();
      control.get('clonedshortURLControl').setValue(this.shortUrl[i].url);
      control.disable({ onlySelf: true });
      this.clonedShortUrls.push({ ...this.shortUrl[i] });
      (<FormArray>this.clonedFormDetails.get('clonedShortUrlGroup')).push(control);
    }
    this.basicDetailsEdit = true;
  }

  resetShortUrl() {
    this.clonedShortUrls = new Array<{ url, isSaved }>();
    (<FormArray>this.clonedFormDetails.get('clonedShortUrlGroup')).clear();
  }

  editLanguageBasedDetails(event, index) {
    this.spinner.show();
    this.approver = '';
    this.engagementDetailsHistoryId = 0;
    let engagementDynamicDetails = { ... this.engagementDynamicDetails[index] };
    this.engagementManagementService.getSaveEngagementDraft(engagementDynamicDetails.engagementDetailsId).subscribe((response) => {
      if (response.responseStatus == 1) {

      } else {
        this.clonedLanguageBasedDetails = { ... this.engagementDynamicDetails[index] };
        if (response.data) {
          this.engagementDetailsHistoryId = response.data.engagementDetailsHistoryId;
          this.clonedLanguageBasedDetails.engagementDetailsId = response.data.engagementDetailsId;
          this.clonedLanguageBasedDetails.engagementName = response.data.engagementName;
          this.clonedLanguageBasedDetails.descritpion = response.data.engagementDescription;
          this.approver = response.data.authorizedBy ? response.data.authorizedBy : ''
          this.clonedLanguageBasedDetails.status = "Draft";
          this.cloneEngagementDetails
        } else {
          this.engagementDetailsHistoryId = 0
        }
        this.showLanguageBasedDetails = true;
      }
      this.spinner.hide();
    });
  }

  jurisdictionValidation(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (control.touched && control.value && control.value?.jurisdictionOfFilingId > 0) {
        return null;
      } else if (!control.touched && control.value && control.value?.jurisdictionOfFilingId > 0) {
        return null;
      }
      return { 'jurisdictionRequired': 'Jurisdiction is required' };
    }
  }

  engagementNameDuplicateValidator(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<{ [key: string]: any | null }> => {
      if ((control.dirty) && control?.value.length > 0) {
        return this.engagementManagementService.validateEngagementName(control.value, this.engagementMemoryService.getEngagementId());
      }
      return of(null);
    }
  }

  updateEngagementBasicInfo() {
    if (this.clonedFormDetails.valid) {
      this.spinner.show();
      let shortUrlString = '';
      (<FormArray>this.clonedFormDetails.get('clonedShortUrlGroup')).controls.forEach((ctrl, index) => {
        if (ctrl.value.clonedshortURLControl && ctrl.value.clonedshortURLControl != '') {
          if (index != 0)
            shortUrlString += '^'
          shortUrlString += this.urlDomain + ctrl.value.clonedshortURLControl
        }
      });
      let model = {
        EngagementId: this.engagementMemoryService.getEngagementId(),
        InitialDate: this.clonedEngagementDetailsForm.IntialDate,
        PastDate: this.clonedEngagementDetailsForm.PastDate?.toLocaleDateString(),
        ShortUrl: shortUrlString,
        EYRole: this.clonedEngagementDetailsForm.EYRole,
        Jurisdiction: this.clonedEngagementDetailsForm.Jurisdiction,
        IsFormal: this.clonedEngagementDetailsForm.IsFormal,
        IsConfidential: this.clonedEngagementDetailsForm.IsConfidential
      }
      this.engagementManagementService.updateEngagementBasicInfo(model).subscribe((response) => {
        this.engagementDetailsForms = { ...this.clonedEngagementDetailsForm };
        this.shortUrl = [];
        (<FormArray>this.clonedFormDetails.get('clonedShortUrlGroup')).controls.forEach((ctrl, index) => {
          this.shortUrl.push({ url: ctrl.value.clonedshortURLControl, isSaved: true })
        });
        this.basicDetailsEdit = false;
        this.messageService.add({
          key: "toast_editbasicdetails",
          summary: this.labelReplacer('Engagementbasicinfoupdatesuccessfully'),
          detail: "",
          sticky: false,
          severity: 'success'
        });
        this.spinner.hide();
      })
    } else {
      this.basicDetailsForm.markAllAsTouched();
    }
  }
  addEngagementDetails(index) {
    let detailGroup = (<FormArray>this.basicDetailsForm.get('engagementLanguageBasedDetails')).at(index);
    if (detailGroup.valid) {
      this.spinner.show();
      let dynamicDetailsModel = this.engagementDynamicDetails[index];
      const engagementDetailsModel = {
        EngagementId: this.engagementMemoryService.getEngagementId(),
        EngagementName: dynamicDetailsModel.engagementName,
        EngagementDescription: dynamicDetailsModel.descritpion,
        LanguageId: dynamicDetailsModel.languageId
      };
      this.engagementManagementService.addEngagementDetails(engagementDetailsModel).subscribe((response) => {
        if (response.responseStatus == 1) {

          this.messageService.add({
            key: "toast_editbasicdetails",
            summary: this.labelReplacer('Erroroccuredwhileaddingengagementdetails'),
            detail: "",
            sticky: false,
            severity: 'error'
          });
        } else {
          this.messageService.add({
            key: "toast_editbasicdetails",
            summary: this.labelReplacer('Engagementdetailsaddedsuccessfully'),
            detail: "",
            sticky: false,
            severity: 'success'
          });
          dynamicDetailsModel.isEditEnabled = true;
          dynamicDetailsModel.isDraftExists = true;
        }
        this.spinner.hide();
      })

    } else
      detailGroup.markAllAsTouched();
  }

  saveEngagementDetailsHistory(event) {
    if (this.clonedLanguageBasedDetailsForm.valid && this.clonedLanguageBasedDetails) {
      let engagementDetailsHistoryModel = {
        EngagementDetailsHistoryId: this.engagementDetailsHistoryId,
        EngagementDetailsId: this.clonedLanguageBasedDetails.engagementDetailsId,
        EngagementName: this.clonedLanguageBasedDetails.engagementName,
        EngagementDescription: this.clonedLanguageBasedDetails.descritpion,
        LanguageId: this.clonedLanguageBasedDetails.languageId
      }
      this.spinner.show()
      this.engagementManagementService.addorupdateEngagementDetails(engagementDetailsHistoryModel).subscribe((response) => {
        if (response.responseStatus == 1) {
          //alert("Error occured while updating engagement details");
          this.messageService.add({
            key: "toast_editbasicdetails",
            summary: this.labelReplacer('Erroroccuredwhileupdatingengagementdetails'),
            detail: "",
            sticky: false,
            severity: 'error'
          });
        } else {
          // alert("Engagement details updated successfully");
          this.messageService.add({
            key: "toast_editbasicdetails",
            summary: this.labelReplacer('Engagementdetailsupdatedsuccessfully'),
            detail: "",
            sticky: false,
            severity: 'success'
          });
          let dynamicDetails = this.engagementDynamicDetails.find(t => t.engagementDetailsId == this.clonedLanguageBasedDetails.engagementDetailsId);
          if (dynamicDetails.status == "Draft") {
            dynamicDetails.descritpion = this.clonedLanguageBasedDetails.descritpion;
            dynamicDetails.engagementName = this.clonedLanguageBasedDetails.engagementName;
          }
          dynamicDetails.isDraftExists = true;
          this.engagementDetailsHistoryId = response.data;
          this.clonedLanguageBasedDetails.status = "Draft";
        }
        this.spinner.hide();
      })
    } else {
      this.clonedLanguageBasedDetailsForm.markAllAsTouched();
    }
  }

  approveEngagementDetails(event) {
    this.spinner.show();
    this.engagementManagementService.approveEngagementDetails(this.engagementMemoryService.getEngagementId(), this.clonedLanguageBasedDetails.engagementDetailsId).subscribe((response) => {
      if (response.responseStatus == 1) {
        this.messageService.add({
          key: "toast_editbasicdetails",
          summary: this.labelReplacer('Erroroccuredwhileupdatingengagementstatus'),
          detail: "",
          sticky: false,
          severity: 'error'
        });
      } else {
        if (response.data) {

          this.messageService.add({
            key: "toast_editbasicdetails",
            summary: this.labelReplacer('Engagementstatusupdatedsuccessfully'),
            detail: "",
            sticky: false,
            severity: 'success'
          });
          let dynamicDetails = this.engagementDynamicDetails.find(t => t.engagementDetailsId == response.data.engagementDetailsId)
          dynamicDetails.descritpion = response.data.engagementDescription;
          dynamicDetails.engagementName = response.data.engagementName;
          dynamicDetails.status = this.status.find(t => t.statusId == response.data.statusId).name;
          dynamicDetails.statusId = response.data.statusId;
          dynamicDetails.isDraftExists = false;
          this.showLanguageBasedDetails = false;
        }
      }
      this.spinner.hide();
    })
  }

  getUnselectedLanguages() {
    let languageList = this.engagementMemoryService.getLanguages();
    let selectedLanguage = this.engagementMemoryService.getSelectedLanguages();
    languageList.forEach(element => {
      let languageModel = this.engagementMemoryService.getSelectedLanguages().find(t => t.languageId == element.languageId);
      if (!languageModel)

        this.languageDropDown.push(element);
    })
  }

  showAddEngagementDetails(event) {
    this.addEnagementDetailsForm.reset();
    this.addEnagementDetailsModel = new DynamicDetailsModel("", "", "", "", 0, 0, false, false, 0, "", false);
    this.addDeltailsSelectedLanguage = "";
    this.showAddEnagementBasedDetails = true;
  }

  addEngagementDetailsHistory(event) {
    if (this.addEnagementDetailsForm.valid) {
      const engagementDetailsModel = {
        EngagementId: this.engagementMemoryService.getEngagementId(),
        EngagementName: this.addEnagementDetailsModel.engagementName,
        EngagementDescription: this.addEnagementDetailsModel.descritpion,
        LanguageId: this.addDeltailsSelectedLanguage.languageId
      };
      this.spinner.show();
      this.engagementManagementService.addEngagementDetails(engagementDetailsModel).subscribe((response) => {
        if (response.responseStatus == 1) {
          //alert("Error occured while updating engagement details");
          this.messageService.add({
            summary: this.labelReplacer('Erroroccuredwhileupdatingengagementdetails'),
            detail: "",
            sticky: false,
            severity: 'error'
          });
        } else {
          //alert("Engagement details added successfully");
          this.messageService.add({
            key: "toast_editbasicdetails",
            summary: this.labelReplacer('Engagementdetailsaddedsuccessfully'),
            detail: "",
            sticky: false,
            severity: 'success'
          });
          this.addEnagementDetailsModel.engagementDetailsId = response.data.engagementDetailsId
          this.addEnagementDetailsModel.languageId = this.addDeltailsSelectedLanguage.languageId;
          this.addEnagementDetailsModel.language = this.addDeltailsSelectedLanguage.name;
          this.addEnagementDetailsModel.isEditEnabled = true;
          this.addEnagementDetailsModel.statusId = 1;
          this.addEnagementDetailsModel.status = "Draft"
          let dynamicModel: DynamicDetailsModel = { ... this.addEnagementDetailsModel };
          dynamicModel.isDraftExists = true;
          this.engagementDynamicDetails.push(dynamicModel);
          (<FormArray>this.basicDetailsForm.get('engagementLanguageBasedDetails')).push(this.getEngagementDetailsFormGroup(dynamicModel));
          this.engagementMemoryService.addSelectedLanguage({ ...this.addDeltailsSelectedLanguage });
          this.languageDropDown = [];
          this.getUnselectedLanguages();
          this.showAddEnagementBasedDetails = false;
        }
        this.spinner.hide();
      })
    } else {
      this.addEnagementDetailsForm.markAllAsTouched();
    }
  }

  addLanguageValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (control.touched && control.value && control.value?.languageId > 0) {
        return null;
      } else if (!control.touched && control.value && control.value?.languageId > 0) {
        return null;
      }
      return { 'addLanguageRequired': 'Jurisdiction is required' };
    }
  }

  getApproverList(engagementId) {
    this.manageDocService.getApproverList(engagementId).subscribe(res => {
      if (res.status === 0) {
        //success
        this.rawApproverList = res.data;
        this.formatApproverList()
          .then(res => { })
          .catch(error => console.log(error));
      } else {

      }
    });
  }
  formatApproverList() {
    return new Promise((resolve, reject) => {
      let ownerList, reviewerList, partnerList, srMangerList, adminList: any[] = [];

      this.authorizerList = [];

      this.authorizerList.push({
        label: this.labelReplacer('lblOwner'),
        items: []
      });
      this.authorizerList.push({
        label: this.labelReplacer('lblReviewer'),
        items: []
      });
      this.authorizerList.push({
        label: this.labelReplacer('lblPPAP'),
        items: []
      });
      this.authorizerList.push({
        label: this.labelReplacer('lblSrManager'),
        items: []
      });
      this.authorizerList.push({
        label: this.labelReplacer('lblAdmin'),
        items: []
      });

      if (this.rawApproverList.length > 0) {
        ownerList = this.rawApproverList[0];
        reviewerList = this.rawApproverList[1];
        partnerList = this.rawApproverList[2];
        srMangerList = this.rawApproverList[3];
        adminList = this.rawApproverList[4];
        this.setDesignationList(ownerList, 0);
        this.setDesignationList(reviewerList, 1);
        this.setDesignationList(partnerList, 2);
        this.setDesignationList(srMangerList, 3);
        this.setDesignationList(adminList, 4);
      }
      resolve(1);
    }).catch(error => {
      console.log(error);
    })
  }
  setDesignationList(userList, index) {
    if (userList.length > 0) {
      this.authorizerList[index].items = userList.map(x => ({
        label: x.emailId,
        value: x.userId
      }));
    }
  }
  approverChange(event) {
    if (event.value == this.loggedInUserModel.userId) {
      this.isSameApproverSelected = true;
    } else {
      this.isSameApproverSelected = false;
    }
  }

  sendForApproval(event) {
    if (this.engagementDetailsHistoryId > 0 && this.approver && this.approver > 0) {
      this.spinner.show()
      this.engagementManagementService.sendForApproval(this.engagementDetailsHistoryId, this.approver).subscribe((response) => {
        if (response.responseStatus == 1) {
          this.messageService.add({
            key: "toast_editbasicdetails",
            summary: this.labelReplacer('Erroroccuredwhilesendingforapproval'),
            detail: "",
            sticky: false,
            severity: 'error'
          });
        } else {
          this.messageService.add({
            key: "toast_editbasicdetails",
            summary: this.labelReplacer('Engagementdetailssentforapproval'),
            detail: "",
            sticky: false,
            severity: 'success'
          });
          this.showLanguageBasedDetails = false;
        }
        this.spinner.hide();
      })
    }
  }

  getStatusSpillClass(status: string) {
    if (status) {
      status = status.toLowerCase();
      if (status == "live" || status == "approved")
        return 'pill pill--approved';
      else if (status == "taken down" || status == "suspended")
        return 'pill pill--failed';
      return 'pill pill--closed'
    }
  }
  showEngagementDetailsLog(event, index) {
    this.spinner.show();
    this.showLog = true;
    let engagementDynamicDetails = { ... this.engagementDynamicDetails[index] };
    this.engagementManagementService.getEngagementDetailsHistory(engagementDynamicDetails.engagementDetailsId).subscribe((response: any) => {
      if (response.responseStatus == 1) {
        this.messageService.add({
          key: "toast_editbasicdetails",
          summary: this.labelReplacer('Erroroccuredwhilesendingforapproval'),
          detail: "",
          sticky: false,
          severity: 'error'
        });
      } else {
        if (response.data && response.data.length > 0)
          this.engagementDetailsLog = response.data
      }
      this.spinner.hide();
    })

  }
}

export class EngagementDetailsForm {
  IntialDate: Date;
  IsFormal: boolean;
  ShortUrl: string;
  IsConfidential: boolean;
  PastDate: Date;
  EYRole: any;
  Jurisdiction: any;
  constructor(intialDate: Date, isFormal: boolean, shortUrl: string, isConfidential: boolean, eyRole: any, jurisdiction: any) {
    this.IntialDate = intialDate;
    this.IsFormal = isFormal;
    this.ShortUrl = shortUrl;
    this.IsConfidential = isConfidential;
    this.EYRole = eyRole;
    this.Jurisdiction = jurisdiction;
  }
}

export class DynamicDetailsModel {
  engagementName: string;
  descritpion: string;
  language: string;
  eyRole: any;
  languageId: number;
  engagementDetailsId: number;
  isEditEnabled: boolean;
  statusId: number;
  status: string;
  aprrover: any;
  isDraftExists: boolean;
  constructor(engagementName: string, descritpion: string, language: string, eyRole: any, languageId: number, engagementDetailsId: number, isEdit: boolean, isEditEnabled: boolean, statusId: number, status: string, isDraftExists: boolean) {
    this.engagementName = engagementName;
    this.descritpion = descritpion;
    this.language = language;
    this.eyRole = eyRole;
    this.languageId = languageId;
    this.engagementDetailsId = engagementDetailsId;
    this.isEditEnabled = isEditEnabled;
    this.statusId = statusId;
    this.status = status;
    this.isDraftExists = false;
  }
}

export class engagementDetailsHistory {
  engagementName: string;
  engagementDescription: string;
  engagementApprovedEmail

}
